/*
 * Statusseite für Bewerber.
 *
 * Der Token steht als ?token=… in der URL — er ist der einzige Nachweis, den
 * ein Bewerber hat. Deshalb: nie in einen Link auf eine fremde Seite schreiben,
 * nie in den Verlauf pushen, nie in eine Fehlermeldung aufnehmen. Er geht
 * ausschließlich im Body der Proxy-Aufrufe raus.
 */
(function () {
  'use strict'

  var API = '/apps/jobs/api'

  function strings(root) {
    try {
      return JSON.parse(root.dataset.strings || '{}')
    } catch (e) {
      return {}
    }
  }

  function show(el) {
    if (el) el.hidden = false
  }
  function hide(el) {
    if (el) el.hidden = true
  }
  function target(root, name) {
    return root.querySelector('[data-target="' + name + '"]')
  }
  function slot(root, name) {
    return root.querySelector('[data-slot="' + name + '"]')
  }

  function fail(root, message) {
    hide(target(root, 'loading'))
    var box = target(root, 'error')
    if (box) {
      box.textContent = message
      show(box)
    }
  }

  async function postJSON(url, payload) {
    var res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    })
    var body = await res.json().catch(function () {
      return null
    })
    return { ok: res.ok, status: res.status, body: body || {} }
  }

  function toBase64(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader()
      reader.onload = function () {
        var s = String(reader.result)
        resolve(s.slice(s.indexOf(',') + 1))
      }
      reader.onerror = reject
      reader.readAsDataURL(file)
    })
  }

  function formatDate(value) {
    var d = new Date(value)
    if (isNaN(d.getTime())) return ''
    return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' })
  }

  var KIND_LABEL = {
    COVER_LETTER: 'Bewerbungsschreiben',
    CV: 'Lebenslauf',
    PHOTO: 'Foto',
    CERTIFICATE: 'Zeugnis',
    OTHER: 'Sonstiges',
  }

  function renderDocuments(root, documents) {
    var list = slot(root, 'documents')
    var empty = slot(root, 'documents-empty')
    list.textContent = ''

    if (!documents || documents.length === 0) {
      hide(list)
      show(empty)
      return
    }
    hide(empty)
    show(list)

    documents.forEach(function (doc) {
      var li = document.createElement('li')
      // Bewusst kein Download-Link: Die Unterlagen liegen in einem privaten
      // Bucket, und ein Bewerber, der seinen Lebenslauf sucht, hat ihn selbst.
      // Hier steht nur, was bei uns angekommen ist.
      li.textContent = (KIND_LABEL[doc.kind] || doc.kind) + ': ' + doc.name
      var span = document.createElement('span')
      span.className = 'job-status-doc-date'
      span.textContent = ' (' + formatDate(doc.uploadedAt) + ')'
      li.appendChild(span)
      list.appendChild(li)
    })
  }

  function render(root, application, t) {
    // Nach einem Upload lädt die Seite neu — der Knopf ist dann noch von
    // vorhin gesperrt.
    var attachButton = target(root, 'attach-submit')
    if (attachButton) attachButton.disabled = false

    slot(root, 'job').textContent = application.jobTitle
    slot(root, 'name').textContent = application.name
    slot(root, 'submitted').textContent = formatDate(application.submittedAt)
    slot(root, 'status').textContent = application.statusText

    renderDocuments(root, application.documents)

    if (application.canAttach) show(slot(root, 'attach-wrap'))
    if (application.canWithdraw) show(slot(root, 'withdraw-wrap'))

    hide(target(root, 'loading'))
    show(target(root, 'article'))
  }

  function wireAttach(root, token, t) {
    var input = target(root, 'attach-input')
    var button = target(root, 'attach-submit')
    var status = target(root, 'attach-status')
    if (!input || !button) return

    button.addEventListener('click', async function () {
      var files = Array.prototype.slice.call(input.files || [])
      if (files.length === 0) return

      button.disabled = true
      status.className = 'job-upload-status'
      status.textContent = t.upload_pending || '…'
      show(status)

      try {
        var uploaded = []
        for (var i = 0; i < files.length; i++) {
          var file = files[i]
          var dataBase64 = await toBase64(file)
          var up = await postJSON(API + '/upload', {
            name: file.name,
            type: file.type,
            // Nachgereichtes ordnen wir nicht automatisch ein — welche Art
            // Dokument das ist, entscheidet die Person, die es liest.
            kind: 'OTHER',
            dataBase64: dataBase64,
          })
          if (!up.ok || !up.body.ok) {
            status.className = 'job-upload-status is-error'
            status.textContent = up.body.message || t.error_text
            button.disabled = false
            return
          }
          uploaded.push(up.body.file)
        }

        var res = await postJSON(API + '/status', {
          token: token,
          intent: 'attach',
          files: uploaded,
        })
        if (!res.ok || !res.body.ok) {
          status.className = 'job-upload-status is-error'
          status.textContent = res.body.message || t.error_text
          button.disabled = false
          return
        }

        status.className = 'job-upload-status is-ok'
        status.textContent = res.body.message
        input.value = ''
        // Frisch laden, damit die Liste der Unterlagen stimmt.
        load(root, token, t)
      } catch (e) {
        status.className = 'job-upload-status is-error'
        status.textContent = t.error_text
        button.disabled = false
      }
    })
  }

  function wireWithdraw(root, token, t) {
    var button = target(root, 'withdraw')
    var status = target(root, 'withdraw-status')
    if (!button) return

    button.addEventListener('click', async function () {
      if (!window.confirm(t.withdraw_confirm || 'Bewerbung zurückziehen?')) return
      button.disabled = true

      var res = await postJSON(API + '/status', { token: token, intent: 'withdraw' })
      status.textContent = res.body.message || (res.body.ok ? '' : t.error_text)
      show(status)
      if (res.body.ok) {
        hide(button)
        load(root, token, t)
      } else {
        button.disabled = false
      }
    })
  }

  async function load(root, token, t) {
    // GET mit dem Token im Query-String: Der Proxy signiert den ganzen
    // Request, und die URL verlässt den Browser nur Richtung getdigital.de.
    var res = await fetch(API + '/status?token=' + encodeURIComponent(token), {
      headers: { Accept: 'application/json' },
    })
    var body = await res.json().catch(function () {
      return null
    })
    if (!body) return fail(root, t.error_text)
    if (!body.ok) return fail(root, body.message || t.error_text)

    hide(target(root, 'error'))
    render(root, body.application, t)
  }

  function init() {
    var root = document.querySelector('[data-job-status]')
    if (!root) return
    var t = strings(root)

    var token = new URLSearchParams(window.location.search).get('token')
    if (!token) {
      return fail(root, t.missing_token_text)
    }

    wireAttach(root, token, t)
    wireWithdraw(root, token, t)

    load(root, token, t).catch(function () {
      fail(root, t.error_text)
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()
